export function animateAccountCreditApplied(card) {
    if (!card || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
        return;
    }
    card.classList.remove('account-credit--just-applied');
    void card.offsetWidth;
    card.classList.add('account-credit--just-applied');
    card.addEventListener('animationend', () => {
        card.classList.remove('account-credit--just-applied');
    }, { once: true });
}
